import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from '@env/environment';
import { AuthService } from '../services/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
private auth: AuthService, private router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    // Dove l'applicazione e' pubblica non c'e' nulla da verificare: senza
    // questo ramo il guard chiederebbe un token che nessuno ha chiesto e
    // rimbalzerebbe ogni visita su /login.
    if (!environment.auth.required) {
      return true;
    }
    if (!await this.auth.isAuthenticated()) {
      this.router.navigate(['/login']);
      return false;
    }
    if (!await this.auth.checkGroupMembership()) {
      this.router.navigate(['/unauthorized']);
      return false;
    }
    return true;
  }
}